// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:23:36.957Z
// Property: Cameron Run (ID: 6767906449167331)
// Collections: 17 amenities, 3 floorplans (live), 22 photos, 40 POIs, 3 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167331",
  "property_external_id": "100160114",
  "property_zillow_url": "https://www.zillow.com/apartments/east-pt-ga/cameron-run/5XrQ7n/",
  "property_apartments_url": "https://www.apartments.com/cameron-run-east-point-ga/kv36wsb/",
  "property_google_business_url": "https://www.google.com/maps/place/Cameron+Run/data=!4m2!3m1!1s0x0:0x8eff51fa7538cb4d?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cameron-run",
  "property_name": "Cameron Run",
  "property_website_url": "https://www.liveatcameronrun.com/",
  "property_domain": "https://www.liveatcameronrun.com/",
  "property_address": "4395 Washington Rd",
  "property_full_address": "4395 Washington Rd, East Point, GA 30344",
  "property_address_1": "4395 Washington Rd",
  "property_address_2": null,
  "property_address_city": "East Point",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30344",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "South Fulton",
  "property_address_latitude": "33.6340564",
  "property_address_longitude": "-84.495015",
  "property_email": "cameronrun@axiares.com",
  "property_phone": "(833) 436-7519",
  "property_call_tracking_phone": "855-614-0565",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to Cameron Run in East Point, GA, where comfort meets style. Choose from spacious one, two, and three-bedroom floor plans featuring modern amenities like a fitness center, swimming pool, and pet-friendly spaces. Experience lush landscaping and convenient living to make every day feel like a retreat. Your ideal home awaits!",
  "property_long_description": "Welcome to Cameron Run, your ideal apartment community nestled in the heart of East Point, GA. With carefully designed floor plans to suit every lifestyle, our one, two, and three-bedroom apartments provide the perfect balance of comfort and convenience. Each spacious unit boasts modern features, including equipped kitchens, washer and dryer connections, and walk-in closets, complemented by stylish wood plank flooring and cozy carpeted bedrooms.\n\nAt Cameron Run, we’re more than just an apartment community—we're a lifestyle. Enjoy an array of amenities that make every day feel like a vacation. Dive into relaxation at our sparkling swimming pool, break a sweat in our state-of-the-art fitness center, or enjoy a fun-filled day with family at our playground. Our picnic and BBQ area is perfect for hosting weekend gatherings, all within our beautifully landscaped, gated community.\n\nDesigned with your needs in mind, our on-site professional management team is dedicated to providing unparalleled service, ensuring you feel right at home from day one. Plus, as a pet-friendly community, your furry friends are welcome to enjoy the outdoor spaces alongside you!\n\nCameron Run offers a convenient location, allowing easy access to local shopping, dining, and entertainment, so you can fully embrace the vibrant lifestyle East Point has to offer. \n\nDon’t miss your chance to find your new home today—browse our availability or schedule a tour to experience the charm of Cameron Run for yourself!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-b437-7581-bbf0-1a323d9642cc.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
    "public_id": "019d54e9-b437-7581-bbf0-1a323d9642cc",
    "storage_key": "property/6767906449167331/019d54e9-b437-7581-bbf0-1a323d9642cc.webp",
    "width": 2338,
    "height": 1146
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "270",
  "property_year_built": "1973",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "85.92592592592592",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "65",
  "property_pet_restrictions": "We welcome cats and dogs up to 65 lbs. Maximum 2 pets per unit.",
  "property_pet_policy_description": "We welcome cats and dogs up to 65 lbs. Pet fee: $350 one-time. Monthly pet rent: $25 per pet. Maximum 2 pets per unit.",
  "property_petpolicy_info": "Pet Types: Cats & Dogs\nBreed Restrictions Apply\nMax weight: 65\nMaximum Pets Per Unit: 2",
  "property_online_leasing_url": "https://cameronrunaxia.prospectportal.com/East Point/Cameron Run",
  "property_resident_portal_url": "https://cameronrunaxia.residentportal.com/auth",
  "property_apply_now_url": "https://cameronrunaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160114/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-b299-70ec-91aa-58d511d4e946.webp",
  "property_primary_logo_media": {
    "alt_text": "Cameron Run Apartment Homes logo with building and leaf icon.",
    "public_id": "019d54e9-b299-70ec-91aa-58d511d4e946",
    "storage_key": "property/6767906449167331/019d54e9-b299-70ec-91aa-58d511d4e946.webp",
    "width": 175,
    "height": 80
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019ddf7f-52b1-719f-8f6c-db2a3cfc7cfd.webp",
  "property_fav_icon_media": {
    "alt_text": "Blue circle icon",
    "public_id": "019ddf7f-52b1-719f-8f6c-db2a3cfc7cfd",
    "storage_key": "property/6767906449167331/019ddf7f-52b1-719f-8f6c-db2a3cfc7cfd.webp",
    "width": 48,
    "height": 48
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-e136-720b-a33e-b743710bb9b1.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54e9-e136-720b-a33e-b743710bb9b1",
    "storage_key": "property/6767906449167331/019d54e9-e136-720b-a33e-b743710bb9b1.webp",
    "width": 175,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-d627-74d9-a871-fe5b087e9ce1.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54e9-d627-74d9-a871-fe5b087e9ce1",
    "storage_key": "property/6767906449167331/019d54e9-d627-74d9-a871-fe5b087e9ce1.webp",
    "width": 175,
    "height": 80
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "742 - 1176",
  "property_sqft_min": "742",
  "property_sqft_max": "1176",
  "property_price_range": "$950 - $1499",
  "property_price_min": "950",
  "property_price_max": "1499",
  "property_available_units": 38,
  "property_facebook_url": "https://www.facebook.com/CameronRunApts",
  "property_instagram_url": "https://www.instagram.com/cameronrunapartments/",
  "property_twitter_url": "https://x.com/cameronrunapt",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGZkCFkzi9IgRTcs4dfpR_44",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cameron-run-apartment-homes-east-point",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cameron Run",
  "property_home_romance_title": "Experience the Charm of Your New Home Sweet Home",
  "property_home_amenities_blurb": "Welcome to Cameron Run, your ideal retreat in East Point, GA. Choose from spacious one, two, or three-bedroom apartments designed for comfort and convenience. Enjoy our pet-friendly community, relax by the swimming pool, or break a sweat in the fitness center. Experience a vibrant lifestyle with lush landscaping and tailored amenities just for you!",
  "property_home_floorplans_blurb": "At Cameron Run in East Point, GA, we offer thoughtfully designed floor plans to fit every lifestyle. Choose from cozy one-bedroom retreats to spacious three-bedroom homes. Each apartment provides a welcoming atmosphere, ready for your personal touch. Browse our available options and find your ideal living space today!",
  "property_home_gallery_blurb": "At Cameron Run in East Point, GA, spacious one, two, and three-bedroom apartments await you. Enjoy modern amenities like a fitness center, a sparkling swimming pool, and a pet-friendly environment nestled amidst lush landscaping. Picture yourself living here, where comfort and convenience come together seamlessly!",
  "property_home_neighborhood_blurb": "Nestled in East Point, GA, Cameron Run offers spacious one, two, and three-bedroom floor plans surrounded by vibrant local attractions. Unwind at Cascade Springs Nature Preserve, hit a round at Wolf Creek Golf Club, or explore the rich history at Hapeville Depot Museum. Embrace a community where convenience meets adventure!",
  "property_home_reviews_blurb": "At Cameron Run in vibrant East Point, GA, residents rave about their welcoming community: “The staff is friendly, and the atmosphere feels like home.” Embrace a lifestyle where comfort meets convenience. Curious about what makes us special? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in East Point, GA, Cameron Run offers more than just exceptional floor plans. Embrace a vibrant community with attractions like the Delta Flight Museum, stunning Cascade Springs Nature Preserve, and the engaging Hapeville Depot Museum. Uncover an array of cultural landmarks and recreational spaces that enrich your living experience.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Cameron Run in East Point, GA, where modern living meets vibrant community life. Choose from spacious one, two, and three-bedroom apartments, all featuring wood plank flooring and walk-in closets. Enjoy our fitness center and sparkling swimming pool, nestled within lush landscaping, for a lifestyle that embraces comfort and convenience.",
  "property_applynow_blurb": "At Cameron Run in East Point, GA, your ideal home awaits with spacious one, two, and three-bedroom floor plans designed for comfort. Enjoy a lifestyle enriched by a fitness center, a relaxing swimming pool, and a pet-friendly atmosphere. Lease online today and embrace vibrant living surrounded by lush landscaping!",
  "property_contactus_blurb": "At Cameron Run in East Point, GA, stylish floor plans await your discovery. Choose from one, two, or three-bedroom layouts thoughtfully designed for modern living. Our welcoming leasing team is eager to assist you in finding your perfect home. Have questions? Drop us a line today!",
  "property_faqs_blurb": "At Cameron Run in East Point, GA, we offer a variety of floor plans tailored to fit your lifestyle—choose from one, two, or three-bedroom apartments. Curious about our community? Visit our FAQs page to get the insights you need for a seamless living experience.",
  "property_floorplans_blurb": "Embrace comfort at Cameron Run in East Point, GA, where our thoughtfully designed one, two, and three-bedroom apartments cater to every lifestyle. With spacious layouts and modern amenities, you'll feel right at home. Browse our available options today and envision your next chapter in a community that truly welcomes you.",
  "property_gallery_blurb": "At Cameron Run in East Point, GA, vibrant living meets comfort in one, two, and three-bedroom apartments. Envision sunny days spent at the swimming pool, evening BBQs under the stars, and tranquil walks through lush landscaping. Picture your new lifestyle and all the amenities waiting for you to enjoy!",
  "property_interactivemap_blurb": "Welcome to Cameron Run in East Point, GA, where spacious one, two, and three-bedroom apartments blend luxury with comfort. Enjoy top-notch amenities like a vibrant fitness center, refreshing swimming pool, and lush landscaping—all in a gated community. Uncover your ideal space using our interactive community map today!",
  "property_pets_blurb": "At Cameron Run, we recognize that pets are family. Our pet-friendly apartment community welcomes up to two companions per home, giving them ample space to feel comfortable. Our thoughtfully landscaped grounds offer a pleasant environment for walks and playtime, while nearby parks add even more options for outdoor fun. For any questions about our pet policy, our leasing team is always happy to assist you.",
  "property_referafriend_blurb": "At Cameron Run in East Point, GA, great friends make great neighbors! Share the joy of upscale living by referring a friend to our vibrant community, boasting one, two, and three-bedroom floor plans designed for modern comfort. Invite them to experience a lifestyle where connections flourish!",
  "property_residentaccess_blurb": "Welcome to Cameron Run, your ideal East Point, GA haven. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your unique lifestyle. Seamlessly manage your home by accessing our resident portal to pay rent, schedule maintenance, and elevate your living experience today!",
  "property_reviews_blurb": "At Cameron Run in East Point, GA, residents rave about the \"exceptional sense of community and friendly neighbors.\" Our vibrant atmosphere and top-notch amenities create a home where you truly belong. Curious about life here? See what our residents have to say about living at our community!",
  "property_created_at": "1775246035156",
  "property_scheduletour_blurb": "At Cameron Run in East Point, GA, vibrant living awaits with thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Schedule a tour today and see what our residents love about calling this community home. Their stories may just inspire your next move!",
  "property_thankyou_blurb": "Thank you for reaching out! At Cameron Run in East Point, GA, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom homes—offer something for everyone. Keep an eye on your inbox; a team member will be in touch to help you find your perfect space soon!",
  "property_virtualtours_blurb": "Step into comfort at Cameron Run in East Point, GA, where modern living meets spacious designs. Choose from charming one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Ready to envision your new home? Take a virtual tour today and experience the community firsthand!",
  "property_copyright": "2026 All Rights Reserved. Cameron Run",
  "property_seo_title_home": "Cameron Run |  Apartments in East Point, GA",
  "property_seo_description_home": "Welcome to Cameron Run in East Point, GA! Choose from one, two, or three-bedroom apartments featuring top amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | East Point, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Cameron Run in East Point, GA. Choose from stylish one, two, or three-bedroom floor plans and make it your own!",
  "property_seo_title_amenities": "Amenities | East Point, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Cameron Run in East Point, GA. Enjoy a pet-friendly oasis with a fitness center, swimming pool, and spacious floor plans!",
  "property_seo_title_gallery": "Gallery | Apartments in East Point, GA",
  "property_seo_description_gallery": "Experience life at Cameron Run in East Point, GA! Spacious, pet-friendly apartments with a pool, fitness center, and beautiful landscaping await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Cameron Run Apartments",
  "property_seo_description_virtualtours": "Experience Cameron Run in East Point, GA! Take a virtual tour of our stylish one, two, and three-bedroom apartments—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Cameron Run Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Cameron Run in East Point, GA! Enjoy spacious apartments, resort-style amenities, and a pet-friendly community!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in East Point, GA",
  "property_seo_description_neighborhood": "Explore the lively community around Cameron Run in East Point, GA, and find local favorites near your new one, two, or three-bedroom home!",
  "property_seo_title_contact": "Contact Us | Cameron Run",
  "property_seo_description_contact": "Reach out to Cameron Run in East Point, GA! Our friendly leasing team is ready to answer all your queries about our one, two, and three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in East Point, GA",
  "property_seo_description_faqs": "Find answers to your questions about life at Cameron Run in East Point, GA. Enjoy spacious living, pet-friendly amenities, and a welcoming community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in East Point, GA",
  "property_seo_description_reviews": "Explore Cameron Run in East Point, GA! Discover spacious living, great amenities, and a pet-friendly community from current residents!",
  "property_seo_title_applynow": "Apply Now | Apartments in East Point, GA",
  "property_seo_description_applynow": "Elevate your lifestyle at Cameron Run, East Point, GA! Enjoy spacious apartments, a pool, fitness center, and pet-friendly spaces. Apply online!",
  "property_seo_title_residentaccess": "Resident Access | Cameron Run",
  "property_seo_description_residentaccess": "Log in to Cameron Run’s resident portal for hassle-free rent payments, maintenance requests, and community updates in beautiful East Point, GA!",
  "property_seo_title_referafriend": "Refer A Friend | Cameron Run",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Cameron Run in East Point, GA, and share the joy of comfortable living in our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cameron Run",
  "property_seo_description_scheduletour": "Experience modern living at Cameron Run in East Point, GA. Schedule your tour today and find your perfect apartment in a vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Cameron Run",
  "property_seo_description_privacy": "Your privacy matters at Cameron Run in East Point, GA. Read our policy for a transparent look at how we protect your information. Stay informed!",
  "property_seo_title_accessibility": "Website Accessibility | Cameron Run",
  "property_seo_description_accessibility": "Cameron Run in East Point, GA champions digital inclusion. We strive to make every visitor feel at home with accessible resources. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Cameron Run",
  "property_seo_description_sitemap": "Navigate your way to home at Cameron Run in East Point, GA. Find every amenity and feature we offer with our comprehensive sitemap—your new life awaits!",
  "property_seo_title_thankyou": "Thank You | Cameron Run",
  "property_seo_description_thankyou": "Thank you for reaching out to Cameron Run in East Point, GA! Our team will be in touch soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in East Point, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793451343",
  "amenities": [
    {
      "id": "custom_cc8e15cd-bf7c-43f6-ab67-f6b10d7bb159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8fcbf74-99ea-4397-888b-bea31b5d3211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2876f4d-f7d0-4c14-bc6d-af41d28952c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a704fce-6930-45bd-97d9-90f109da4982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86857bf9-c487-4253-a566-a530683bfccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic and BBQ Area",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1120eef-4389-4d19-9532-29d807b61d5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Professional Management",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2f748d6-ab6f-424b-96b8-71286f001dc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Landscaping",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71be8826-be3b-42e0-aeed-f0c631ac6591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Surface Lot Parking",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abfc0da9-efe9-4a24-8f6a-f9b81e792e1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dba3cc37-fa07-4810-942d-aa21bdf5d554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "Found under “Community Amenities” on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eef5de1b-da50-4074-adf2-546d59703888",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Washer / Dryer Connections",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5ce5f42-5ca1-4f0c-9066-d9d86ed58af5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Rooms",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72a90f28-f732-429d-80f9-0cea4c977d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5244bac-0eea-439a-b1ea-d407d2b224e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plank Flooring",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5e82c24-f5d1-4bf9-a5fe-d21da7e38f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f865251-fdb1-4948-954a-b9bf531eca96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03a6af7d-23c6-4f65-8b86-52c08e24f232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "external_id": "false",
      "title": "Equipped Kitchen",
      "amount": "false",
      "description": "Found under “Apartment Amenities” on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_5a73937d-43b2-4757-97f6-6d99327a9b75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3c3c-77d8-9633-73801bda03f8.webp",
      "image_media": {
        "alt_text": "King-size bed with orange and floral pillows in a bedroom with a closet and ensuite bathroom. Explore apartments for rent in East Point GA near Atlanta airport—schedule your tour today or call for more information.",
        "public_id": "019e02b1-3c3c-77d8-9633-73801bda03f8",
        "storage_key": "property/6767906449167331/019e02b1-3c3c-77d8-9633-73801bda03f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-size bed, plush carpeting, ample closet space, and a convenient ensuite bathroom.",
      "link": "",
      "alt_text": "King-size bed with orange and floral pillows in a bedroom with a closet and ensuite bathroom. Explore apartments for rent in East Point GA near Atlanta airport—schedule your tour today or call for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_770811d5-dfda-4886-a258-47235a1115f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-9ccc-752d-b515-6bdf7911f878.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with brick accents, large trees, and a parking lot. Discover luxury apartments in East Point GA with pool—book a tour or contact us to learn more.",
        "public_id": "019e02b1-9ccc-752d-b515-6bdf7911f878",
        "storage_key": "property/6767906449167331/019e02b1-9ccc-752d-b515-6bdf7911f878.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment complex exterior, featuring charming architecture, manicured lawns, and convenient parking.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with brick accents, large trees, and a parking lot. Discover luxury apartments in East Point GA with pool—book a tour or contact us to learn more.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_776007e8-2b72-4be1-8821-46645d4d81c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-6f7a-74ee-8e24-eff3e7966a0e.webp",
      "image_media": {
        "alt_text": "Black electric stove with oven and four burners, situated in a kitchen with wood cabinets and granite countertops. Find pet friendly apartments in East Point GA—schedule a visit or call today for details.",
        "public_id": "019e02b1-6f7a-74ee-8e24-eff3e7966a0e",
        "storage_key": "property/6767906449167331/019e02b1-6f7a-74ee-8e24-eff3e7966a0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A close-up view of a kitchen featuring a black electric stove with an oven, complete with four burners. The stove is placed against a speckled granite countertop, complemented by warm wooden cabinetry and a stainless steel range hood.",
      "link": "",
      "alt_text": "Black electric stove with oven and four burners, situated in a kitchen with wood cabinets and granite countertops. Find pet friendly apartments in East Point GA—schedule a visit or call today for details.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d517ba2-4ebe-4383-9342-7bfdd84ef549",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-7746-754f-91e2-287fe9e271fe.webp",
      "image_media": {
        "alt_text": "Bedroom with a purple comforter and desk. Tour 1 bedroom apartments in East Point GA near MARTA—contact our team for more information.",
        "public_id": "019e02b1-7746-754f-91e2-287fe9e271fe",
        "storage_key": "property/6767906449167331/019e02b1-7746-754f-91e2-287fe9e271fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen-sized bed with a purple comforter, a white bookshelf headboard, and a dedicated study area with a desk and chair.",
      "link": "",
      "alt_text": "Bedroom with a purple comforter and desk. Tour 1 bedroom apartments in East Point GA near MARTA—contact our team for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1495eecb-8019-41b5-9399-d9f4451cd1f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-7282-70bb-8ee3-ec5f57d7b61b.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk, chair, dresser, and a bed. Browse apartments near MARTA station East Point GA—schedule your tour or call to learn more.",
        "public_id": "019e02b1-7282-70bb-8ee3-ec5f57d7b61b",
        "storage_key": "property/6767906449167331/019e02b1-7282-70bb-8ee3-ec5f57d7b61b.webp",
        "width": 3072,
        "height": 1878
      },
      "title": "Apartment",
      "description": "This bedroom features a desk with a chair, a dresser, and a bed with purple bedding. Decorated with colorful art and a mirror.",
      "link": "",
      "alt_text": "Bedroom with a desk, chair, dresser, and a bed. Browse apartments near MARTA station East Point GA—schedule your tour or call to learn more.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-40eb-750b-896f-cf5278fb2873.webp",
      "image_media": {
        "alt_text": "Swimming pool and playground area with lounge chairs and trees. Explore apartments in East Point GA near Tyler Perry Studios—book a tour or contact us today.",
        "public_id": "019e02b1-40eb-750b-896f-cf5278fb2873",
        "storage_key": "property/6767906449167331/019e02b1-40eb-750b-896f-cf5278fb2873.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or let the kids have fun at the playground. Outdoor lounging and relaxation await.",
      "link": "",
      "alt_text": "Swimming pool and playground area with lounge chairs and trees. Explore apartments in East Point GA near Tyler Perry Studios—book a tour or contact us today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83dfafbb-3b89-4b32-ba5c-8cf9c7609827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-8247-742c-b4a1-591ef0a4bef6.webp",
      "image_media": {
        "alt_text": "Exterior view of the leasing center with a manicured lawn and landscaping. Discover gated apartments in East Point GA—schedule a tour or call for availability details.",
        "public_id": "019e02b1-8247-742c-b4a1-591ef0a4bef6",
        "storage_key": "property/6767906449167331/019e02b1-8247-742c-b4a1-591ef0a4bef6.webp",
        "width": 3072,
        "height": 1496
      },
      "title": "Community",
      "description": "Welcome to our leasing center, the first stop for finding your new home.",
      "link": "",
      "alt_text": "Exterior view of the leasing center with a manicured lawn and landscaping. Discover gated apartments in East Point GA—schedule a tour or call for availability details.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3385643e-708e-49a6-bf38-b155c7ec7c3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-7dd8-755c-aec7-867dcb55bb92.webp",
      "image_media": {
        "alt_text": "Bathroom with a wooden vanity, white toilet, and a tropical-themed shower curtain View apartments for rent in East Point GA with parking—schedule your tour or call for more information.",
        "public_id": "019e02b1-7dd8-755c-aec7-867dcb55bb92",
        "storage_key": "property/6767906449167331/019e02b1-7dd8-755c-aec7-867dcb55bb92.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and refreshing bathroom featuring a wooden vanity, modern toilet, and a vibrant shower curtain with a tropical leaf pattern.",
      "link": "",
      "alt_text": "Bathroom with a wooden vanity, white toilet, and a tropical-themed shower curtain View apartments for rent in East Point GA with parking—schedule your tour or call for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a3884eb-02da-4377-be4d-1689d200e51d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-7701-7449-8459-190c97d1e2cc.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, black stove, black refrigerator, and double sink. Check out apartments in East Point GA near downtown Atlanta—book a tour or contact us today.",
        "public_id": "019e02b1-7701-7449-8459-190c97d1e2cc",
        "storage_key": "property/6767906449167331/019e02b1-7701-7449-8459-190c97d1e2cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring ample cabinet space, a full-size black appliance package, and a double sink.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, black stove, black refrigerator, and double sink. Check out apartments in East Point GA near downtown Atlanta—book a tour or contact us today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e0c33f5-4980-4cbe-8186-08d5631123e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-6995-7594-97f4-1e4d44fa7021.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to kitchen with washer/dryer visible in hallway. Discover Rentals in East Point GA—book a tour today or contact us for more information.",
        "public_id": "019e02b1-6995-7594-97f4-1e4d44fa7021",
        "storage_key": "property/6767906449167331/019e02b1-6995-7594-97f4-1e4d44fa7021.webp",
        "width": 3072,
        "height": 1908
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, perfect for intimate gatherings. The adjacent kitchen and convenient in-unit laundry make everyday living a breeze.",
      "link": "",
      "alt_text": "Dining area adjacent to kitchen with washer/dryer visible in hallway. Discover Rentals in East Point GA—book a tour today or contact us for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f08df560-16d6-4906-ab3d-30b8edc21552",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3a71-71ee-a491-fcd8b04e9201.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a laundry basket on top, and a sign that says laundry. View 1-bedroom apartments for rent in East Point GA—schedule a tour or call to learn more.",
        "public_id": "019e02b1-3a71-71ee-a491-fcd8b04e9201",
        "storage_key": "property/6767906449167331/019e02b1-3a71-71ee-a491-fcd8b04e9201.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs. Includes a stylish laundry basket and a decorative sign.",
      "link": "",
      "alt_text": "In-unit washer and dryer with a laundry basket on top, and a sign that says laundry. View 1-bedroom apartments for rent in East Point GA—schedule a tour or call to learn more.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3e88-7599-a16a-6d90af8b517c.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with treadmills, ellipticals, weight machines, and free weights. Tour apartments in East Point GA with fitness center—call today or schedule a visit to learn more.",
        "public_id": "019e02b1-3e88-7599-a16a-6d90af8b517c",
        "storage_key": "property/6767906449167331/019e02b1-3e88-7599-a16a-6d90af8b517c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fully equipped fitness center with treadmills, ellipticals, weight machines, and free weights. Tour apartments in East Point GA with fitness center—call today or schedule a visit to learn more.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e19f106f-8772-4deb-966a-f24b7d6dddf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-4a05-738d-8850-5a227c317cbe.webp",
      "image_media": {
        "alt_text": "Bedroom with queen-size bed, dresser, nightstand, and window. Explore 2 bedroom apartments in East Point GA—schedule your tour or contact us for details.",
        "public_id": "019e02b1-4a05-738d-8850-5a227c317cbe",
        "storage_key": "property/6767906449167331/019e02b1-4a05-738d-8850-5a227c317cbe.webp",
        "width": 3072,
        "height": 2058
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage with a dresser and nightstand, and a bright window overlooking the community.",
      "link": "",
      "alt_text": "Bedroom with queen-size bed, dresser, nightstand, and window. Explore 2 bedroom apartments in East Point GA—schedule your tour or contact us for details.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3cbf-735c-bf94-cc7da3700f61.webp",
      "image_media": {
        "alt_text": "Spacious fenced-in dog park area with green turf and a playground in the background. Discover apartments near Camp Creek Marketplace East Point GA—book a tour or call for more information.",
        "public_id": "019e02b1-3cbf-735c-bf94-cc7da3700f61",
        "storage_key": "property/6767906449167331/019e02b1-3cbf-735c-bf94-cc7da3700f61.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, perfect for your furry friends to play and socialize. Features artificial turf for year-round enjoyment and a nearby playground for children.",
      "link": "",
      "alt_text": "Spacious fenced-in dog park area with green turf and a playground in the background. Discover apartments near Camp Creek Marketplace East Point GA—book a tour or call for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8f14f29-82a9-447c-a8a4-a9713a3cb9df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-4c91-71cf-87cd-6da6e6de7018.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a couch, coffee table, dining table, and accent bench. Find 1-bedroom apartments in East Point GA—schedule a tour or contact us today to learn more.",
        "public_id": "019e02b1-4c91-71cf-87cd-6da6e6de7018",
        "storage_key": "property/6767906449167331/019e02b1-4c91-71cf-87cd-6da6e6de7018.webp",
        "width": 3072,
        "height": 1954
      },
      "title": "Apartment",
      "description": "Stylish living and dining area with comfortable seating, a modern rug, and decorative accents. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with a couch, coffee table, dining table, and accent bench. Find 1-bedroom apartments in East Point GA—schedule a tour or contact us today to learn more.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96df4395-d48f-44ac-8314-960f930f88dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-44ea-73db-97aa-94df02a941ac.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sectional sofa, ottoman coffee table, and modern decor. Browse 2-bedroom apartments in East Point GA—book your visit or call for availability.",
        "public_id": "019e02b1-44ea-73db-97aa-94df02a941ac",
        "storage_key": "property/6767906449167331/019e02b1-44ea-73db-97aa-94df02a941ac.webp",
        "width": 3072,
        "height": 1925
      },
      "title": "Apartment",
      "description": "Relax in comfort in this stylish living room featuring a plush sectional sofa, a convenient ottoman coffee table, and vibrant artwork.",
      "link": "",
      "alt_text": "Cozy living room with a sectional sofa, ottoman coffee table, and modern decor. Browse 2-bedroom apartments in East Point GA—book your visit or call for availability.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_073c95ad-911c-4308-955c-0395c3b2c94e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3cbf-735c-bf94-c965f358acc1.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a playground in the background. Tour 3-bedroom apartments in East Point GA—contact us today or schedule your visit online.",
        "public_id": "019e02b1-3cbf-735c-bf94-c965f358acc1",
        "storage_key": "property/6767906449167331/019e02b1-3cbf-735c-bf94-c965f358acc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with ample lounge seating and a fun-filled playground for the kids.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a playground in the background. Tour 3-bedroom apartments in East Point GA—contact us today or schedule your visit online.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0086a3e-0406-49b8-9cdf-6db84fd921c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-3e87-736f-93ba-c59e3adc7baf.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and artwork. Explore apartments for rent in East Point GA—schedule a tour or call for more details.",
        "public_id": "019e02b1-3e87-736f-93ba-c59e3adc7baf",
        "storage_key": "property/6767906449167331/019e02b1-3e87-736f-93ba-c59e3adc7baf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and bright bathroom, featuring a spacious vanity with a large mirror, a convenient toilet, and decorative artwork to enhance the ambiance.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and artwork. Explore apartments for rent in East Point GA—schedule a tour or call for more details.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019f4d36-9356-720b-84de-ba521feb92fa.webp",
      "image_media": {
        "alt_text": "People enjoying the swimming pool and lounge chairs at a multifamily property.",
        "public_id": "019f4d36-9356-720b-84de-ba521feb92fa",
        "storage_key": "property/6767906449167331/019f4d36-9356-720b-84de-ba521feb92fa.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and a vibrant atmosphere.",
      "link": "",
      "alt_text": "People enjoying the swimming pool and lounge chairs at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019f4d36-5451-72fb-a00c-268ac9b5da4d.webp",
      "image_media": {
        "alt_text": "People exercising in a well-equipped gym with treadmills, elliptical, weight machines, and free weights.",
        "public_id": "019f4d36-5451-72fb-a00c-268ac9b5da4d",
        "storage_key": "property/6767906449167331/019f4d36-5451-72fb-a00c-268ac9b5da4d.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines, weight training equipment, and free weights for a complete workout experience.",
      "link": "",
      "alt_text": "People exercising in a well-equipped gym with treadmills, elliptical, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cfc48237-6fef-4927-864b-0906ef52f44e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019f4d36-29cd-717f-8c21-354f290bbd0c.webp",
      "image_media": {
        "alt_text": "People and dogs enjoying a fenced-in dog park with green grass and trees.",
        "public_id": "019f4d36-29cd-717f-8c21-354f290bbd0c",
        "storage_key": "property/6767906449167331/019f4d36-29cd-717f-8c21-354f290bbd0c.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "This community offers a fantastic dog park where residents and their furry friends can play and socialize in a safe, fenced environment.",
      "link": "",
      "alt_text": "People and dogs enjoying a fenced-in dog park with green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_543d2fd0-7d7d-4eef-9fcb-1c259ea61ab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019f4d3a-1d89-712a-878d-4b1661bb5004.webp",
      "image_media": {
        "alt_text": "Young couple walking dog, people dining outdoors, woman walking with coffee, train at station, airport, and city skyline.",
        "public_id": "019f4d3a-1d89-712a-878d-4b1661bb5004",
        "storage_key": "property/6767906449167331/019f4d3a-1d89-712a-878d-4b1661bb5004.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Lifestyle",
      "description": "Experience a vibrant lifestyle with convenient access to dining, transportation, and urban attractions.",
      "link": "",
      "alt_text": "Young couple walking dog, people dining outdoors, woman walking with coffee, train at station, airport, and city skyline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_71185b52-52cd-4682-b4b6-5701d9acfc6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "461 N Central Ave, Hapeville, GA 30354, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers a unique menu with items like chicken and waffles, burgers, and a variety of pies, alongside the classic Chick-fil-A chicken sandwich. They highlight the nostalgic diner vibe, the clean and organized space, and the fun, family-friendly atmosphere. They also like the friendly, knowledgeable, and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d5a6-771f-977a-06bccf132a7a.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with red roof and shutters.",
        "public_id": "019d54e8-d5a6-771f-977a-06bccf132a7a",
        "storage_key": "property/6767906449167331/019d54e8-d5a6-771f-977a-06bccf132a7a.webp",
        "width": 2048,
        "height": 1152
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/the-dwarf-house?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3148851995774726875&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.6563816",
      "poi_longitude": "-84.4040053",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-762-1746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54e9-8496-75be-a2c2-c4032d02d2a8",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWcM_3D99IgR27Ju8jT4sis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_4346115b-5fdc-4049-8945-129f6d879301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "The Breakfast Boys",
      "poi_type": "Restaurants",
      "poi_address": "3387 Main St, College Park, GA 30337, USA",
      "poi_short_description": "Laid-back restaurant for breakfast, brunch fare including waffles and pancakes, plus beer, wine and cocktails.",
      "poi_long_description": "People say this brunch restaurant serves delicious catfish, shrimp, and grits, as well as jerk chicken and sweet potato waffles. They highlight the generous portions, flavorful dishes, and the quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d4af-7338-82fb-398fbbab954b.webp",
      "poi_featured_image_media": {
        "alt_text": "People dining at tables outside a restaurant with blue awnings and hanging ferns.",
        "public_id": "019d54e8-d4af-7338-82fb-398fbbab954b",
        "storage_key": "property/6767906449167331/019d54e8-d4af-7338-82fb-398fbbab954b.webp",
        "width": 750,
        "height": 750
      },
      "poi_business_url": "https://eatatbreakfastboys.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9281321928327950859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-breakfast-boys",
      "poi_latitude": "33.6632935",
      "poi_longitude": "-84.44647959999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 470-312-2108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54e9-8496-75be-a2c2-c4032d02d2a8",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX5ADStfj9IgRC_IHiB7hzYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_56b984ca-954d-41f9-b8db-d625e988d84e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Malone's",
      "poi_type": "Restaurants",
      "poi_address": "1258 Virginia Ave, Atlanta, GA 30344, USA",
      "poi_short_description": "Steak, ribs & seafood (plus large brew list) in casual setting near airport with outdoor seating.",
      "poi_long_description": "Diners say this steakhouse serves up delicious shrimp and grits, pork chops, pecan crusted chicken, and catfish. They also highlight the friendly and attentive service, and the lively atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-dce7-73a2-bd54-4a8894b9ea23.webp",
      "poi_featured_image_media": {
        "alt_text": "Malone's Bar & Grill building with an upper-level outdoor seating area and a parking lot.",
        "public_id": "019d54e8-dce7-73a2-bd54-4a8894b9ea23",
        "storage_key": "property/6767906449167331/019d54e8-dce7-73a2-bd54-4a8894b9ea23.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.malonesatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8085207990139432583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "malones",
      "poi_latitude": "33.6585624",
      "poi_longitude": "-84.4300638",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-762-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54e9-8496-75be-a2c2-c4032d02d2a8",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdV4tk_99IgRhy5pa9RtNHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4a5550cc-c4c0-421b-bd09-d455902d1310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Buttermilk Biscuit",
      "poi_type": "Restaurants",
      "poi_address": "1634 Virginia Ave, Atlanta, GA 30337, USA",
      "poi_short_description": "Breakfast restaurant specializing in hearty Southern classics like grits and biscuits, in a cozy space.",
      "poi_long_description": "People say this breakfast restaurant serves delicious catfish, shrimp and grits, and biscuits and gravy. They also highlight the friendly and attentive service, and the fun and energetic atmosphere.\n\nOther reviews mention the space can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-e131-75dd-8b9e-7475e5f8256d.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor seating area with tables and chairs in front of a restaurant.",
        "public_id": "019d54e8-e131-75dd-8b9e-7475e5f8256d",
        "storage_key": "property/6767906449167331/019d54e8-e131-75dd-8b9e-7475e5f8256d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.buttermilkbiscuitatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=832809295870799811&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buttermilk-biscuit",
      "poi_latitude": "33.6584273",
      "poi_longitude": "-84.442743",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-941-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54e9-8496-75be-a2c2-c4032d02d2a8",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd5JuJrLj9IgRw68FZqS7jgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ea3b375d-1ccc-4900-95b4-f65d545afe2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Spondivits",
      "poi_type": "Restaurants",
      "poi_address": "1219 Virginia Ave, East Point, GA 30344, USA",
      "poi_short_description": "Since 1979, this down-home seafood restaurant & bar has served Angus beef, chowder, gumbo & oysters.",
      "poi_long_description": "People say this seafood restaurant serves delicious seafood, including crab legs, oysters, and lobster buckets. They also highlight the lively atmosphere, the generous portions, and the friendly service.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-da9b-75eb-85b5-62a0b43e0980.webp",
      "poi_featured_image_media": {
        "alt_text": "Entrance to a bar and grill with neon palm tree and sun sign.",
        "public_id": "019d54e8-da9b-75eb-85b5-62a0b43e0980",
        "storage_key": "property/6767906449167331/019d54e8-da9b-75eb-85b5-62a0b43e0980.webp",
        "width": 3072,
        "height": 1382
      },
      "poi_business_url": "http://www.spondivitsworldfamous.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11756910905930330887&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spondivits",
      "poi_latitude": "33.6591915",
      "poi_longitude": "-84.42904279999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-767-1569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54e9-8496-75be-a2c2-c4032d02d2a8",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-c4032d02d2a8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSEsyU_99IgRB7Pkmy3wKKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_b1471685-e574-4865-a2d6-1ee136cfe93c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Camp Creek Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "3480 Marketplace Blvd, East Point, GA 30344, USA",
      "poi_short_description": "Shopping complex with discount department, big-box & specialty stores, assorted services & dining.",
      "poi_long_description": "Shopping complex with discount department, big-box & specialty stores, assorted services & dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d53d-72ea-a879-c1e62e604f84.webp",
      "poi_featured_image_media": {
        "alt_text": "Row of retail stores with various signs including H&R Block, WNB Factory, and Mattress Firm.",
        "public_id": "019d54e8-d53d-72ea-a879-c1e62e604f84",
        "storage_key": "property/6767906449167331/019d54e8-d53d-72ea-a879-c1e62e604f84.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10800586827984078181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "camp-creek-marketplace",
      "poi_latitude": "33.6580831",
      "poi_longitude": "-84.5025423",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-729-0422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face.",
        "public_id": "019d54e9-84a6-7648-9bf9-c721b7ab9618",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP-6cXBPi9IgRZQXB_35k45U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fc852290-ecaa-4be9-98da-570792314bc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Old National Discount Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2660 Godby Rd, College Park, GA 30349, USA",
      "poi_short_description": "Shopping mall featuring a variety of vendors, including those for shoes, custom T-shirts, and art.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and products, including clothing, shoes, jewelry, and accessories. They also highlight the good deals, the friendly people, and the fun, unique shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d4d5-700b-b42c-47e8477e93f7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Discount Mall building with signage.",
        "public_id": "019d54e8-d4d5-700b-b42c-47e8477e93f7",
        "storage_key": "property/6767906449167331/019d54e8-d4d5-700b-b42c-47e8477e93f7.webp",
        "width": 506,
        "height": 458
      },
      "poi_business_url": "https://www.instagram.com/creativecustoms_of_atl?igshid=ZGNjOWZkYTE3MQ==&utm_source=qr",
      "poi_directions_map_url": "https://maps.google.com/?cid=1186082002979020589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-national-discount-mall",
      "poi_latitude": "33.6152629",
      "poi_longitude": "-84.47541629999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-881-5992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face.",
        "public_id": "019d54e9-84a6-7648-9bf9-c721b7ab9618",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv1eY0Qjj9IgRLV8MLkzPdRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4b00411e-a68f-4db3-b4d0-b1427f6abde9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "H Mart Riverdale",
      "poi_type": "Shopping & Retail",
      "poi_address": "6335 GA-85 T, Riverdale, GA 30274, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "People say this grocery store offers a wide selection of Asian, Caribbean, and other international foods, including fresh seafood, meats, and produce. They also highlight the good prices, the fast-moving lines, and the extensive selection of Korean products.\n\nOther reviews mention the produce can be spoiled.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-e394-713a-9087-2e27c5dc025b.webp",
      "poi_featured_image_media": {
        "alt_text": "Super H Mart building exterior with grand opening banner.",
        "public_id": "019d54e8-e394-713a-9087-2e27c5dc025b",
        "storage_key": "property/6767906449167331/019d54e8-e394-713a-9087-2e27c5dc025b.webp",
        "width": 3072,
        "height": 2040
      },
      "poi_business_url": "http://www.hmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8856476576301505585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-riverdale",
      "poi_latitude": "33.5828934",
      "poi_longitude": "-84.41264340000001",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-435-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84b2-702e-a8b4-9506432d77b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54e9-84b2-702e-a8b4-9506432d77b7",
        "storage_key": "property/6767906449167331/019d54e9-84b2-702e-a8b4-9506432d77b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfOT55389IgRMdwExIWG6Ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_54b57b9f-5636-42f4-8516-0834c3da988b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Publix Super Market at Princeton Lakes",
      "poi_type": "Shopping & Retail",
      "poi_address": "3730 Carmia Dr SW #200, Atlanta, GA 30331, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, quality meats, and delicious baked goods. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the deli can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d57e-7011-9f8b-0ad8ee2a320d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Publix Food & Pharmacy store.",
        "public_id": "019d54e8-d57e-7011-9f8b-0ad8ee2a320d",
        "storage_key": "property/6767906449167331/019d54e8-d57e-7011-9f8b-0ad8ee2a320d.webp",
        "width": 2529,
        "height": 1420
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1056&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=15512759848586561818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-princeton-lakes",
      "poi_latitude": "33.6564029",
      "poi_longitude": "-84.510747",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-346-9253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84b2-702e-a8b4-9506432d77b7.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54e9-84b2-702e-a8b4-9506432d77b7",
        "storage_key": "property/6767906449167331/019d54e9-84b2-702e-a8b4-9506432d77b7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm08qexfi9IgRGsnxZORkSNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_052e1d17-9209-4551-b007-51d31a343a58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3604 Marketplace Blvd, East Point, GA 30344, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of items, including clothing, shoes, and home goods. They also highlight the great prices and unbeatable sales.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-d53e-735d-81de-f7c03a5d50b8.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Ross Dress for Less store with its signage.",
        "public_id": "019d54e8-d53e-735d-81de-f7c03a5d50b8",
        "storage_key": "property/6767906449167331/019d54e8-d53e-735d-81de-f7c03a5d50b8.webp",
        "width": 1841,
        "height": 1037
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477528771721851625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.6598752",
      "poi_longitude": "-84.5025645",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-344-1578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face.",
        "public_id": "019d54e9-84a6-7648-9bf9-c721b7ab9618",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c721b7ab9618.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeyNqQhPi9IgR6XJq0ueoZ5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_2d713068-ef0e-4372-adb5-f2d190dd9552",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Delta Flight Museum",
      "poi_type": "Entertainment",
      "poi_address": "1060 Delta Blvd, Atlanta, GA 30354, USA",
      "poi_short_description": "Kid-friendly museum tracing the history of Delta Airlines with hands-on exhibits & vintage aircraft.",
      "poi_long_description": "People say this museum offers a fascinating look at the history of aviation and Delta Airlines, with many different aircraft to explore and touch. They highlight the informative exhibits, the opportunity to walk through some of the aircraft, and the fun flight simulator experience. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-ed7c-74fe-ac4e-a70fc085e25d.webp",
      "poi_featured_image_media": {
        "alt_text": "The Spirit of Delta airplane on display",
        "public_id": "019d54e8-ed7c-74fe-ac4e-a70fc085e25d",
        "storage_key": "property/6767906449167331/019d54e8-ed7c-74fe-ac4e-a70fc085e25d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://deltamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14806394729199660301&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delta-flight-museum",
      "poi_latitude": "33.656077",
      "poi_longitude": "-84.4223542",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-715-7886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M inside.",
        "public_id": "019d54e9-8496-75be-a2c2-cb971a6a44d6",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdkSfUT99IgRDW0p_o7hes0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_18f217a8-a081-4651-bbaf-00b1dea711d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "The Gateway Center Arena @ College Park",
      "poi_type": "Entertainment",
      "poi_address": "2330 Convention Center Concourse, College Park, GA 30337, USA",
      "poi_short_description": "Venue hosting games, graduations, and other events, with a restroom.",
      "poi_long_description": "People say this arena offers a great view from any seat and a wide variety of food and drink options. They highlight the convenient parking, easy access, and clean facilities. They also like the spacious layout and the exciting atmosphere, especially during games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-efa5-73ac-8b16-6cf5d871e77d.webp",
      "poi_featured_image_media": {
        "alt_text": "Gateway Center Arena at College Park exterior with a large red entrance and signage.",
        "public_id": "019d54e8-efa5-73ac-8b16-6cf5d871e77d",
        "storage_key": "property/6767906449167331/019d54e8-efa5-73ac-8b16-6cf5d871e77d.webp",
        "width": 3072,
        "height": 1730
      },
      "poi_business_url": "https://gatewaycenterarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1716442134233780236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-gateway-center-arena--college-park",
      "poi_latitude": "33.6468849",
      "poi_longitude": "-84.4596328",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-857-1245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SrLmo7j9IgRDJCE6AYH0hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5088f86a-1d3d-4408-afad-21003080aba8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "The Teaching Museum South",
      "poi_type": "Entertainment",
      "poi_address": "689 North Ave, Hapeville, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-fced-73fb-86b5-ce00990fda31.webp",
      "poi_featured_image_media": {
        "alt_text": "People gathered in a large room with rows of chairs, tables with laptops, and a projector screen.",
        "public_id": "019d54e8-fced-73fb-86b5-ce00990fda31",
        "storage_key": "property/6767906449167331/019d54e8-fced-73fb-86b5-ce00990fda31.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.fultonschools.org/teachingmuseum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7616749698460578187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-teaching-museum-south",
      "poi_latitude": "33.6656017",
      "poi_longitude": "-84.4112245",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-254-8015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M inside.",
        "public_id": "019d54e9-8496-75be-a2c2-cb971a6a44d6",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxH-72P99IgRi3HO134htGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3a742286-fba3-42a3-bdfb-e5f1fd64d5e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Badgett Stadium",
      "poi_type": "Entertainment",
      "poi_address": "3636 College St, College Park, GA 30337, USA",
      "poi_short_description": "Public running track with stadium bleachers for fans of the ball games and other sports held here.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-ee21-737f-b5d4-470918c8aef0.webp",
      "poi_featured_image_media": {
        "alt_text": "Running track with people in the distance",
        "public_id": "019d54e8-ee21-737f-b5d4-470918c8aef0",
        "storage_key": "property/6767906449167331/019d54e8-ee21-737f-b5d4-470918c8aef0.webp",
        "width": 1170,
        "height": 2080
      },
      "poi_business_url": "http://collegeparkrca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7007919078605343222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "badgett-stadium",
      "poi_latitude": "33.6566249",
      "poi_longitude": "-84.45221649999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-669-3773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84b9-739b-91f3-78e8240ef27f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of two people sitting at a table.",
        "public_id": "019d54e9-84b9-739b-91f3-78e8240ef27f",
        "storage_key": "property/6767906449167331/019d54e9-84b9-739b-91f3-78e8240ef27f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_9Poxrvi9IgR9kn0vkUhQWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2976dfc4-72ad-4a6d-b9df-639a5a5944be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Hapeville Depot Museum and Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "620 S Central Ave, Hapeville, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a fascinating glimpse into local history, including the airport, community, and the UAW. They highlight the rare antiques, preserved train depot building, and the knowledgeable and friendly staff. They also like the informative guided tours and the opportunity to learn about the past.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-fd5a-7469-b535-f544ebf2136a.webp",
      "poi_featured_image_media": {
        "alt_text": "Hopeville Depot Museum & Visitor Center sign",
        "public_id": "019d54e8-fd5a-7469-b535-f544ebf2136a",
        "storage_key": "property/6767906449167331/019d54e8-fd5a-7469-b535-f544ebf2136a.webp",
        "width": 2950,
        "height": 2950
      },
      "poi_business_url": "https://www.hapevilledepot.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661325715317386633&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hapeville-depot-museum-and-visitor-center",
      "poi_latitude": "33.6588651",
      "poi_longitude": "-84.4095852",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-669-2175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M inside.",
        "public_id": "019d54e9-8496-75be-a2c2-cb971a6a44d6",
        "storage_key": "property/6767906449167331/019d54e9-8496-75be-a2c2-cb971a6a44d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8mGeG_99IgRie1GO74RkU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fddda998-d693-46f9-b341-8d9dd57853ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3755 Carmia Dr SW Ste 700, Atlanta, GA 30331, USA",
      "poi_short_description": "Chain gym with state-of-the-art equipment, a pool, and a basketball court, plus group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e8-fde2-70c7-904d-9b21c7e99cff.webp",
      "poi_featured_image_media": {
        "alt_text": "Gym with rows of dumbbells and weight machines.",
        "public_id": "019d54e8-fde2-70c7-904d-9b21c7e99cff",
        "storage_key": "property/6767906449167331/019d54e8-fde2-70c7-904d-9b21c7e99cff.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=316&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619903021740938548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.6570167",
      "poi_longitude": "-84.5082855",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-344-1248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsc9VFxfi9IgRNFVzNTcNexY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67c08759-fa66-472e-86a7-c85ea9d50309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2841 Greenbriar Pkwy SW Unit B, Atlanta, GA 30331, USA",
      "poi_short_description": "Chain gym within the Greenbriar Mall offering tanning, and spa services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines not typically found at other locations. They also highlight the clean facilities, friendly staff, and convenient location with ample parking.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-0b11-72ab-8041-8d3c24c6408e.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out at a brightly lit Planet Fitness gym with purple and yellow equipment.",
        "public_id": "019d54e9-0b11-72ab-8041-8d3c24c6408e",
        "storage_key": "property/6767906449167331/019d54e9-0b11-72ab-8041-8d3c24c6408e.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/atlanta-greenbriar-pkwy-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5942132143537523260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.6869451",
      "poi_longitude": "-84.4914565",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-494-3211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-IB_ZAd9YgRPAr8p7OxdlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6dbe9543-ea0a-4132-8d1e-e2dc48b163c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Fine Nail",
      "poi_type": "Health and Wellness",
      "poi_address": "2050 Headland Dr, East Point, GA 30344, USA",
      "poi_short_description": "Clean salon featuring manicures and pedicures, along with lash extensions and makeup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-1b6e-7019-9305-5eb9c14993d4.webp",
      "poi_featured_image_media": {
        "alt_text": "Black mannequin hand with long, pointed nails decorated in red, white, and blue. A snake bracelet with jeweled eyes wraps around the wrist.",
        "public_id": "019d54e9-1b6e-7019-9305-5eb9c14993d4",
        "storage_key": "property/6767906449167331/019d54e9-1b6e-7019-9305-5eb9c14993d4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11261294241100284422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fine-nail",
      "poi_latitude": "33.6877778",
      "poi_longitude": "-84.4555556",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-305-9964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5eZM5EMd9YgRBkLvh3InSJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_bd36df43-ed96-41e6-a721-b41d014bf3bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Old National Nails Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5015 Old National Hwy d, Atlanta, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-107c-7503-9f55-b91c3bd15053.webp",
      "poi_featured_image_media": {
        "alt_text": "Welcome to Old National Nail & Spa interior",
        "public_id": "019d54e9-107c-7503-9f55-b91c3bd15053",
        "storage_key": "property/6767906449167331/019d54e9-107c-7503-9f55-b91c3bd15053.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "http://oldnationalnailsspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18141932127207648265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-national-nails-spa",
      "poi_latitude": "33.6185726",
      "poi_longitude": "-84.4734046",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-500-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7IiGSPj9IgRCWx1TSYXxfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_57853b0e-1522-4eb8-a6e1-08f684024d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Union City Veterinary Medical Center & Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "6702 Shannon Pkwy, Union City, GA 30291, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-1cfc-7086-a013-da568a3ba4c9.webp",
      "poi_featured_image_media": {
        "alt_text": "Union City Veterinary Medical Center & Emergency Clinic logo and contact info on an image of a puppy and kitten.",
        "public_id": "019d54e9-1cfc-7086-a013-da568a3ba4c9",
        "storage_key": "property/6767906449167331/019d54e9-1cfc-7086-a013-da568a3ba4c9.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://ucvmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12281976700277074067&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-city-veterinary-medical-center--emergency-clinic",
      "poi_latitude": "33.5727549",
      "poi_longitude": "-84.5387366",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-964-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEY3_drnm9IgRk6ijd7xYcqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_eea76f48-12d4-46d7-8344-8173ff5c46a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "LifeLine Animal Project Spay & Neuter Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2533 Sullivan Rd, Atlanta, GA 30337, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-1f03-7608-8eca-c8b591ee03fc.webp",
      "poi_featured_image_media": {
        "alt_text": "Tortoiseshell cat wearing a cone of shame while sitting on a purple chair.",
        "public_id": "019d54e9-1f03-7608-8eca-c8b591ee03fc",
        "storage_key": "property/6767906449167331/019d54e9-1f03-7608-8eca-c8b591ee03fc.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://lifelineanimal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16048979865979814183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lifeline-animal-project-spay--neuter-clinic",
      "poi_latitude": "33.625047",
      "poi_longitude": "-84.472144",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-973-2881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6AYBgPj9IgRJ4EfLyhuud4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_74bbc7c4-0fd7-4c7f-8bd0-e7a4495f4abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Flower ATL African Braiding Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "2805 Campbellton Rd SW Suite C, Atlanta, GA 30311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-2084-732b-8683-c7845a843b40.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman with long, red box braids standing in front of a decorative wall.",
        "public_id": "019d54e9-2084-732b-8683-c7845a843b40",
        "storage_key": "property/6767906449167331/019d54e9-2084-732b-8683-c7845a843b40.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://flower-atl-african-braiding-studio.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4200590762064991361&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flower-atl-african-braiding-studio",
      "poi_latitude": "33.7008322",
      "poi_longitude": "-84.48058429999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-496-1985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17d5k-Dj9IgRgdSr2wp_Szo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_59823ced-f71d-4a5a-bd3c-1e52a448747a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "/phys. ed./",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Nabell Ave, East Point, GA 30344, USA",
      "poi_short_description": "Friendly gym offering strength-training classes and weightlifting coaching, plus showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-2165-71f4-89fc-90fdbc69af12.webp",
      "poi_featured_image_media": {
        "alt_text": "People exercising in a gym with air bikes and box jumps.",
        "public_id": "019d54e9-2165-71f4-89fc-90fdbc69af12",
        "storage_key": "property/6767906449167331/019d54e9-2165-71f4-89fc-90fdbc69af12.webp",
        "width": 1500,
        "height": 1094
      },
      "poi_business_url": "http://www.physedatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12306989811362548189&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phys-ed",
      "poi_latitude": "33.689419",
      "poi_longitude": "-84.4380094",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-867-6553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXPSNbLi9IgR3cmdOAc2y6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3fad4d66-b906-4ec9-a337-ab2b743497c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Summit South",
      "poi_type": "Health and Wellness",
      "poi_address": "East Point, GA 30344, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-2486-7498-a857-606e895b3954.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Summit South building with trees in front.",
        "public_id": "019d54e9-2486-7498-a857-606e895b3954",
        "storage_key": "property/6767906449167331/019d54e9-2486-7498-a857-606e895b3954.webp",
        "width": 3072,
        "height": 1729
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15758228560775161458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summit-south",
      "poi_latitude": "33.6815992",
      "poi_longitude": "-84.4148148",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 901-440-6101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84b4-7295-85a8-04789fcf838f.webp",
      "poi_map_icon_media": {
        "alt_text": "The letter H logo",
        "public_id": "019d54e9-84b4-7295-85a8-04789fcf838f",
        "storage_key": "property/6767906449167331/019d54e9-84b4-7295-85a8-04789fcf838f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW21I5gC9YgRciZrpmJ5sNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c0828d26-07d8-455f-a1bb-b1322540cb57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Pedia-Doc Children's Medical Center PC",
      "poi_type": "Health and Wellness",
      "poi_address": "3047 Campbellton Rd SW, Atlanta, GA 30311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://smithdennissmithfuneralhome.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1806659962799887868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pedia-doc-childrens-medical-center-pc",
      "poi_latitude": "33.6952995",
      "poi_longitude": "-84.488171",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-349-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84b4-7295-85a8-04789fcf838f.webp",
      "poi_map_icon_media": {
        "alt_text": "The letter H logo",
        "public_id": "019d54e9-84b4-7295-85a8-04789fcf838f",
        "storage_key": "property/6767906449167331/019d54e9-84b4-7295-85a8-04789fcf838f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcT52pId9YgR_JWbAKqLEhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f6fab041-e4d3-4612-bf0f-9ec7a1057fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Cascade Springs Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2852 Cascade Rd, Atlanta, GA 30311, USA",
      "poi_short_description": "Forested 120-acre nature preserve with a trail, waterfall, streams, parking lot & picnic tables.",
      "poi_long_description": "Visitors say this nature preserve offers peaceful hiking trails, a waterfall, and opportunities to connect with nature. They also highlight its relaxing and serene atmosphere, perfect for meditation, family outings, and enjoying the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-24cf-712a-8de4-c4b76ab39ae0.webp",
      "poi_featured_image_media": {
        "alt_text": "Stone structure with arched openings in a wooded area.",
        "public_id": "019d54e9-24cf-712a-8de4-c4b76ab39ae0",
        "storage_key": "property/6767906449167331/019d54e9-24cf-712a-8de4-c4b76ab39ae0.webp",
        "width": 2864,
        "height": 2759
      },
      "poi_business_url": "https://www.atlantatrails.com/hiking-trails/cascade-springs-nature-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10447115514495691202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cascade-springs-nature-preserve",
      "poi_latitude": "33.719509",
      "poi_longitude": "-84.4812907",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8495-71b8-b03a-71913193c27d.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54e9-8495-71b8-b03a-71913193c27d",
        "storage_key": "property/6767906449167331/019d54e9-8495-71b8-b03a-71913193c27d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYf-GwAd9YgRwun8kDWc-5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_00bf4e16-697f-4fdd-be87-4a5f833d5dd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Wolf Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3000 Union Rd SW, Atlanta, GA 30331, USA",
      "poi_short_description": "Public 18-hole golf course with Bermuda greens and a driving range.",
      "poi_long_description": "People say this golf course offers challenging greens and fairways in excellent condition. They also highlight the friendly and accommodating staff, and the great pace of play.\n\nOther reviews mention the amenities can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-36d0-7039-a1e9-729931ce7b8e.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a golf course with winding paths and water features, surrounded by lush green trees.",
        "public_id": "019d54e9-36d0-7039-a1e9-729931ce7b8e",
        "storage_key": "property/6767906449167331/019d54e9-36d0-7039-a1e9-729931ce7b8e.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.wolfcreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6773238143428533718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wolf-creek-golf-club",
      "poi_latitude": "33.6801284",
      "poi_longitude": "-84.58025549999999",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-344-1334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person kicking a ball",
        "public_id": "019d54e9-84a6-7648-9bf9-c9292fa9aea9",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJidBnzN4f9YgR1h0vjjRg_10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f8c4925a-1e7e-4825-81c9-2d273c05a05f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Alfred Tup Holmes Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Wilson Dr SW, Atlanta, GA 30311, USA",
      "poi_short_description": "Laid-back 18-hole course for golfers of all levels.",
      "poi_long_description": "People say this golf course offers decent fairways. They also highlight the great value for the price and the professional staff.\n\nOther reviews mention the tee boxes can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-2c37-7315-a362-f7c75334337a.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course at sunset with a red flag on the green.",
        "public_id": "019d54e9-2c37-7315-a362-f7c75334337a",
        "storage_key": "property/6767906449167331/019d54e9-2c37-7315-a362-f7c75334337a.webp",
        "width": 2048,
        "height": 1657
      },
      "poi_business_url": "http://cityofatlantagolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13780960729965786697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alfred-tup-holmes-golf-course",
      "poi_latitude": "33.7145569",
      "poi_longitude": "-84.4641164",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-753-6158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person kicking a ball",
        "public_id": "019d54e9-84a6-7648-9bf9-c9292fa9aea9",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJDctQZB4d9YgRSfY37cTOP78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_609835a8-b0e4-4e60-b874-b7b480a01333",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "The Golf Club - Piedmont Driving Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4405 Camp Creek Pkwy, Atlanta, GA 30331, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-47b2-73ea-b7d9-79e20d80b151.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course with a long wooden bridge over a lake and rolling green hills under a cloudy blue sky.",
        "public_id": "019d54e9-47b2-73ea-b7d9-79e20d80b151",
        "storage_key": "property/6767906449167331/019d54e9-47b2-73ea-b7d9-79e20d80b151.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.drivingclub.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15413163240118660603&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-golf-club---piedmont-driving-club",
      "poi_latitude": "33.6653644",
      "poi_longitude": "-84.5330866",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-875-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person kicking a ball",
        "public_id": "019d54e9-84a6-7648-9bf9-c9292fa9aea9",
        "storage_key": "property/6767906449167331/019d54e9-84a6-7648-9bf9-c9292fa9aea9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfm9Pf3h9IgR-61h8E2O5tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_8b3e027e-4d06-4141-b4c9-565917e5ca2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Georgia Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3895 Ben Hill Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "Sports-oriented destination with multiple fields for soccer, rugby and ultimate frisbee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-3ab5-75fd-8452-5b2c01dbdf8c.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer field with players and tents under a cloudy sky.",
        "public_id": "019d54e9-3ab5-75fd-8452-5b2c01dbdf8c",
        "storage_key": "property/6767906449167331/019d54e9-3ab5-75fd-8452-5b2c01dbdf8c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://georgiasportspark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13386995773236084965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-sports-park",
      "poi_latitude": "33.6461951",
      "poi_longitude": "-84.5159967",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8495-71b8-b03a-71913193c27d.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54e9-8495-71b8-b03a-71913193c27d",
        "storage_key": "property/6767906449167331/019d54e9-8495-71b8-b03a-71913193c27d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8qYFyTi9IgR5YBkebopyLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c88e5c66-3ece-49ca-90d2-0db292b217e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Suite 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "Visitors say this airport is clean, well-maintained, and easy to navigate, with a wide variety of dining and shopping options. They also highlight the efficient customer service, quick rental car process, and convenient shuttle service.\n\nSome reviews mention the airport can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-3744-739a-84c7-2f1c8267e4d3.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a modern airport terminal with people checking in at Southwest Airlines counters.",
        "public_id": "019d54e9-3744-739a-84c7-2f1c8267e4d3",
        "storage_key": "property/6767906449167331/019d54e9-3744-739a-84c7-2f1c8267e4d3.webp",
        "width": 1600,
        "height": 1069
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8495-71b8-b03a-776690ace31c.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54e9-8495-71b8-b03a-776690ace31c",
        "storage_key": "property/6767906449167331/019d54e9-8495-71b8-b03a-776690ace31c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_a1e90b61-e5b8-4628-b81b-5a10cf31f358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "College Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "3800 Main St, College Park, GA 30337, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this subway station offers convenient access to public transportation and ample parking, including long-term and covered options. They also highlight the helpful and well-trained staff, including train station staff, bus drivers, and security guards.\n\nOther reviews mention the station can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-3ab0-722b-be97-8806df8d7b90.webp",
      "poi_featured_image_media": {
        "alt_text": "Train station platform with a train at the station and signage for Exit and Southbound.",
        "public_id": "019d54e9-3ab0-722b-be97-8806df8d7b90",
        "storage_key": "property/6767906449167331/019d54e9-3ab0-722b-be97-8806df8d7b90.webp",
        "width": 2992,
        "height": 2992
      },
      "poi_business_url": "http://www.itsmarta.com/College-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7366157631704736701&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "college-park",
      "poi_latitude": "33.6516804",
      "poi_longitude": "-84.448801",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszvd7bfi9IgRvSNLpVbZOWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_7939705a-6d02-40f7-8eec-0309a4b0ee90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 S Terminal Pkwy, Atlanta, GA 30337, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this subway station offers convenient access to transportation. They also highlight the ease of navigation and timely information.\n\nOther reviews mention the experience can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-4873-712e-82cf-a93b2d944a77.webp",
      "poi_featured_image_media": {
        "alt_text": "MARTA train station platform with elevator access and signage.",
        "public_id": "019d54e9-4873-712e-82cf-a93b2d944a77",
        "storage_key": "property/6767906449167331/019d54e9-4873-712e-82cf-a93b2d944a77.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.itsmarta.com/Airport.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8413306910069236437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airport",
      "poi_latitude": "33.640868",
      "poi_longitude": "-84.44622849999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFwUs2M3i9IgR1SIEIQ8SwnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_9ef54017-f875-4084-8193-2548052a9062",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "East Point",
      "poi_type": "Transportation & Transit",
      "poi_address": "2848 E Main St, East Point, GA 30344, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-5c52-74d9-8dfd-e3687e606984.webp",
      "poi_featured_image_media": {
        "alt_text": "Escalator on a subway platform with signs for Southbound and Northbound train lines.",
        "public_id": "019d54e9-5c52-74d9-8dfd-e3687e606984",
        "storage_key": "property/6767906449167331/019d54e9-5c52-74d9-8dfd-e3687e606984.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://itsmarta.com/East-Point.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8123495121862776740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "east-point",
      "poi_latitude": "33.6774355",
      "poi_longitude": "-84.4405529",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUcEhlQd9YgRpNc_8cVzvHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_8c855845-1cc7-48d1-8ebe-8b8a4dbbdf66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Airport Retail Management",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy, Atlanta, GA 30320, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-56eb-77dd-ad29-ebdc03dc8596.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of an airport terminal with shops and travelers.",
        "public_id": "019d54e9-56eb-77dd-ad29-ebdc03dc8596",
        "storage_key": "property/6767906449167331/019d54e9-56eb-77dd-ad29-ebdc03dc8596.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10782436719154792857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airport-retail-management",
      "poi_latitude": "33.6412569",
      "poi_longitude": "-84.44453949999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-305-0356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-8495-71b8-b03a-776690ace31c.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54e9-8495-71b8-b03a-776690ace31c",
        "storage_key": "property/6767906449167331/019d54e9-8495-71b8-b03a-776690ace31c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbesjs7i9IgRmYlZehHpopU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_35e5c39c-0f2d-45b4-842b-b2ed9417ec0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Chick-fil-A Support Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5200 Buffington Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches, strips & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches, strips & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-48de-750d-a233-62df58b7b48d.webp",
      "poi_featured_image_media": {
        "alt_text": "Display of famous cars including the Batmobile.",
        "public_id": "019d54e9-48de-750d-a233-62df58b7b48d",
        "storage_key": "property/6767906449167331/019d54e9-48de-750d-a233-62df58b7b48d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/officialrules",
      "poi_directions_map_url": "https://maps.google.com/?cid=5699126295235252851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a-support-center",
      "poi_latitude": "33.6138568",
      "poi_longitude": "-84.4906285",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-765-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSukNL_j9IgRc9KVlStdF08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a4799113-f6ec-4d74-84fd-3f574fa4f55c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Delta World HQ Main Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1030 Delta Blvd, Atlanta, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-5f7d-744c-b4d9-1b0e8de67237.webp",
      "poi_featured_image_media": {
        "alt_text": "Delta airplane model on display in a modern lobby with seating areas.",
        "public_id": "019d54e9-5f7d-744c-b4d9-1b0e8de67237",
        "storage_key": "property/6767906449167331/019d54e9-5f7d-744c-b4d9-1b0e8de67237.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.delta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11228272524889868168&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delta-world-hq-main-entrance",
      "poi_latitude": "33.656406",
      "poi_longitude": "-84.4241517",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Wowj0T99IgRiMdWF1_W0ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c71d2b7a-8417-46e8-82f5-4ee791a4c688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Delta TOC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1775 M H Jackson Service Rd, Atlanta, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-5e37-71ee-8bae-46a7f54a4afb.webp",
      "poi_featured_image_media": {
        "alt_text": "Delta airplane parked on tarmac",
        "public_id": "019d54e9-5e37-71ee-8bae-46a7f54a4afb",
        "storage_key": "property/6767906449167331/019d54e9-5e37-71ee-8bae-46a7f54a4afb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://deltatechops.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14560468659761154869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delta-toc",
      "poi_latitude": "33.6418597",
      "poi_longitude": "-84.41622699999999",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-488-2844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SH-t-L99IgRNYtF9BktEco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_802db209-30cf-49ff-835e-827dee25f2ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Hartsfield Jackson Atlanta International Airport- Office Of Airport Operations",
      "poi_type": "Major Employers & Offices",
      "poi_address": "720 Doug Davis Dr, Atlanta, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-636b-775a-952e-86c0e3752a2a.webp",
      "poi_featured_image_media": {
        "alt_text": "People at Delta airline check-in kiosks in an airport terminal.",
        "public_id": "019d54e9-636b-775a-952e-86c0e3752a2a",
        "storage_key": "property/6767906449167331/019d54e9-636b-775a-952e-86c0e3752a2a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17872534484650881872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport--office-of-airport-operations",
      "poi_latitude": "33.6563517",
      "poi_longitude": "-84.4135419",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-768-4798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRUPOIyWv_B_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_94907328-befb-4a47-a224-969badccb77c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "poi_name": "Delta Admin Bldg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1030 Delta Blvd, Atlanta, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-7062-71a4-9f70-c448a415b0d8.webp",
      "poi_featured_image_media": {
        "alt_text": "Lush green trees and manicured landscaping with blooming white flowers, leading to apartment buildings in the background.",
        "public_id": "019d54e9-7062-71a4-9f70-c448a415b0d8",
        "storage_key": "property/6767906449167331/019d54e9-7062-71a4-9f70-c448a415b0d8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11950630230938462051&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delta-admin-bldg",
      "poi_latitude": "33.656213",
      "poi_longitude": "-84.4238195",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54e9-84e4-7664-8d4b-ce5438b2b6fc",
        "storage_key": "property/6767906449167331/019d54e9-84e4-7664-8d4b-ce5438b2b6fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5Q4ZUT99IgRY6chveAq2aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_396cba64-d794-4c32-9fb8-7e01cf31e17c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_bd086fbd-62d3-448e-a976-af61b546322d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_879cc724-9ea7-40e6-85e3-192816dc495d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_4f751479-b3ec-4cb1-8602-44870db41064",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_e5b144cf-70c7-4fa8-bdda-fc08f36f28d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_10600221-3bd0-4b71-b330-0f7636c2121a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1ba4946f3f4e3c94c5b4f27b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "rating": "5",
      "name": "Shanice Brown",
      "text": "I'm currently looking for my next apartment, and touring Cameron Run was a great experience thanks to Alexis. She was friendly, professional, and incredibly patient. She answered all of my questions thoroughly and made sure I understood everything without ever making me feel rushed. Her positive attitude and excellent customer service really stood out. Thank you, Alexis, for making my apartment search a little less stressful!",
      "date": "2026-07-09",
      "title": "false"
    },
    {
      "id": "ec_2aeae2c5297ebe004d606b58",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "rating": "5",
      "name": "San Gems",
      "text": "It was end of the year and I needed to get a place of my own. Big thanks to Mr. Asen! He was patience, kind, professional, and most importantly he was upfront and honest. His presence and willingness made me feel comfortable and at ease.  I’m Glad I gave Cameron Run a chance thank you to the property Mrs Mia and staff you all were sincere and polite and it is a joy to finally be home.",
      "date": "2025-12-30",
      "title": "false"
    },
    {
      "id": "ec_853769f488fa0d3b0c5c18b4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "rating": "5",
      "name": "LaNecia Caldwell",
      "text": "I went in to get a tour of the apartments. Upon entering the complex I noticed the area is clean and well kept. After entering the leasing office I was welcomed in by property manager Angela. Angela was very respectful polite and professional at all times. She managed to work with residents as well as proving me the info I needed for move in. Staff was also nice and very welcoming. I look forward to being a part of the community. Thank you again Angela for your assistance today.",
      "date": "2026-03-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5628928e2c15c1a92a5d157f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54eb-4020-734e-a86c-84e55ab85cf9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54eb-4020-734e-a86c-84e55ab85cf9",
        "storage_key": "property/6767906449167331/019d54eb-4020-734e-a86c-84e55ab85cf9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,036 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BsKwFSDmNcz"
    },
    {
      "id": "ec_ad82b5bf1cd76811e1d7dfe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54eb-3f6e-72ca-8562-aafdb76d9748.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54eb-3f6e-72ca-8562-aafdb76d9748",
        "storage_key": "property/6767906449167331/019d54eb-3f6e-72ca-8562-aafdb76d9748.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1036SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=d2gmiR6PYTN"
    },
    {
      "id": "ec_1d12fc3a9644ee989336cd7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d54eb-3f6f-77cf-9216-c10b298920ca.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54eb-3f6f-77cf-9216-c10b298920ca",
        "storage_key": "property/6767906449167331/019d54eb-3f6f-77cf-9216-c10b298920ca.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2.5BA - 1176SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iJyEChdrVFd"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-c663-75fa-8201-091df2100b5a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cameron Run Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331"
    },
    {
      "lead_collector_id": "019db23f-c6d6-74b9-9cb4-27e93f362c52",
      "lead_source": "FACEBOOK_ADS",
      "name": "Cameron Run Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331"
    },
    {
      "lead_collector_id": "019db23f-c74b-7533-992a-fee371e3cdcf",
      "lead_source": "LANDING_PAGE",
      "name": "Cameron Run Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-east-point-ga",
      "search_query": "pet-friendly apartments East Point GA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in East Point, GA",
      "h2_subtitle": "Looking for pet-friendly apartments in East Point, GA? Discover Cameron Run's welcoming atmosphere for you and your furry friends.",
      "page_copy": "Welcome to Cameron Run, a premier pet-friendly apartment community located in the heart of East Point, GA. Our spacious layouts and serene environment offer a perfect home for both you and your pets. We understand that pets are family, which is why our community is designed with amenities that cater to all our residents, including your four-legged companions.\n\nAt Cameron Run, we pride ourselves on providing a safe and secure environment with our gated community and on-site professional management team. Not only is our community welcoming and accommodating, but it is also conveniently located near local parks and pet-friendly trails, making it easy to enjoy the outdoors. Whether you're looking to relax at home or explore the neighborhood, our pet-friendly apartments in East Point, GA, offer the perfect balance of comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in East Point, GA",
      "seo_description": "Discover Cameron Run's welcoming pet-friendly apartments in East Point, GA. Ideal for you and your furry friends with great amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "apartments-with-pool-fulton-county",
      "search_query": "apartments with pool Fulton County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Fulton County",
      "h2_subtitle": "Experience top-tier living with our apartments featuring a pool in Fulton County. Enjoy summer days at Cameron Run.",
      "page_copy": "Dive into luxury at Cameron Run, where our apartments in Fulton County offer more than just a place to live. With a shimmering pool as a part of our amenities, residents can enjoy a refreshing swim or leisurely relax by the water. It's the perfect way to unwind after a long day or spend a weekend soaking up the sun.\n\nBeyond our inviting pool, Cameron Run provides a host of conveniences and comforts that suit every lifestyle. Our pet-friendly community is nestled in East Point, within Fulton County, providing easy access to local attractions and transportation. With a state-of-the-art fitness center and professional on-site management, you'll find everything you need right at home. Choose Cameron Run for an unparalleled living experience in Fulton County, where luxury meets comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Fulton County",
      "seo_description": "Cameron Run offers beautiful apartments with a pool in Fulton County. Perfect for relaxation and leisure, coupled with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "gated-community-apartments-30344",
      "search_query": "gated community apartments 30344",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in 30344",
      "h2_subtitle": "Discover serenity at Cameron Run, a premier gated community located in Fulton County in the 30344 area. ",
      "page_copy": "Cameron Run offers apartment homes within a gated community in the 30344 area of East Point. Community features include a controlled-access gate, modern apartment amenities, and convenient access to local services and attractions.\n\nResidents have access to a fitness center, pet-friendly community features, and professional on-site management. Located in Fulton County, Cameron Run provides convenient access to shopping, dining, entertainment, and transportation options throughout the East Point area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in 30344",
      "seo_description": "Explore Cameron Run's gated community apartments in the 30344 area. Enjoy modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-east-point",
      "search_query": "fitness center apartments East Point",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in East Point",
      "h2_subtitle": "Live actively at Cameron Run, where our fitness center apartments in East Point offer state-of-the-art exercise facilities.",
      "page_copy": "Cameron Run offers apartment homes with access to a fitness center in East Point. The fitness center includes equipment for a variety of exercise activities and is available for resident use.\n\nCommunity features include a gated entrance, pet-friendly amenities, and professional on-site management. Located in Fulton County, Cameron Run provides convenient access to local attractions, shopping, dining, transportation, and other area amenities throughout East Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in East Point",
      "seo_description": "Enjoy modern living at Cameron Run's apartments in East Point. Take advantage of an on-site fitness center and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "apartments-with-washer-dryer-connections-ga",
      "search_query": "apartments with washer dryer connections GA",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer in GA",
      "h2_subtitle": "Convenience meets comfort at Cameron Run, featuring apartments with washer dryer connections in Georgia, ensuring easy living.",
      "page_copy": "At Cameron Run, we understand the importance of convenience in daily living, which is why our apartments in Georgia offer washer dryer connections. This feature provides residents with the comfort of doing laundry from the ease of their apartment, making household chores less of a hassle and more of a breeze.\n\nSituated in the heart of East Point, GA, Cameron Run combines the ideal location with luxury amenities. Residents enjoy a secure, gated community with a modern fitness center and professional on-site management. Pet owners will appreciate our pet-friendly atmosphere, and everyone will love the easy access to nearby shops and restaurants. Discover more about living in comfort and convenience with washer dryer connections at Cameron Run.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer in GA",
      "seo_description": "Cameron Run in GA offers apartments with washer dryer connections. Experience the ease of in-unit laundry in a luxurious community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-east-point-ga",
      "search_query": "one bedroom apartments east point ga",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in East Point, GA",
      "h2_subtitle": "Experience comfort and style at Cameron Run, offering spacious one-bedroom apartments in the vibrant East Point, GA area.",
      "page_copy": "Cameron Run offers one-bedroom apartment homes in East Point, GA. These apartment homes feature modern layouts, natural light, and apartment amenities designed to support everyday living.\n\nCommunity features include a gated entrance, fitness center, professional on-site management, and pet-friendly amenities. Located in East Point, Cameron Run provides convenient access to local dining, shopping, entertainment, transportation, and other area attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in East Point, GA",
      "seo_description": "Find your home at Cameron Run with our one-bedroom apartments in East Point, GA, offering modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-fulton-county",
      "search_query": "2 bedroom apartments fulton county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Fulton County",
      "h2_subtitle": "Discover spacious living at Cameron Run with our 2-bedroom apartments nestled in the heart of vibrant Fulton County.",
      "page_copy": "Cameron Run offers two-bedroom apartment homes in Fulton County featuring spacious layouts and modern apartment amenities. These floor plans provide additional living space and practical conveniences designed to support everyday apartment living.\n\nCommunity features include a fitness center, gated entrance, professional on-site management, and pet-friendly amenities. Located in East Point, Cameron Run provides convenient access to local attractions, shopping, dining, transportation options, and other area services throughout Fulton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Fulton County",
      "seo_description": "Explore Cameron Run's 2-bedroom apartments in Fulton County, offering modern living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30344",
      "search_query": "three bedroom apartments near 30344",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 30344",
      "h2_subtitle": "Find spacious three-bedroom apartments near 30344 at Cameron Run, offering ample room for anyone seeking a vibrant community.",
      "page_copy": "Cameron Run offers spacious three-bedroom apartment homes near the 30344 area. These floor plans provide additional living space, flexible layouts, and modern apartment amenities designed to support everyday apartment living.\n\nCommunity features include a fitness center, gated entrance, professional on-site management, and pet-friendly amenities. Located in East Point, Cameron Run provides convenient access to local shopping, dining, transportation options, and other area amenities throughout Fulton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30344",
      "seo_description": "Explore Cameron Run for spacious three bedroom apartments near 30344, featuring modern amenities and a convenient East Point location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "apartments-near-pedia-doc-childrens-medical-center",
      "search_query": "apartments near Pedia-Doc Children's Medical Center East Point",
      "category": "Hospital",
      "h1_title": "Apartments Near Pedia-Doc Children's Medical",
      "h2_subtitle": "Discover ideal living at Cameron Run, offering apartments conveniently located near Pedia-Doc Children's Medical Center in East Point.",
      "page_copy": "Cameron Run offers apartment homes conveniently located near Pedia-Doc Children's Medical Center in East Point. The community provides convenient access to healthcare facilities, local services, shopping, dining, and recreational opportunities.\n\nCommunity features include a gated entrance, fitness center, pet-friendly amenities, and on-site professional management. Cameron Run combines modern apartment amenities with a convenient location near local destinations throughout East Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pedia-Doc Children's Medical Center",
      "seo_description": "Find cozy apartments near Pedia-Doc Children's Medical Center at Cameron Run, offering modern amenities and a prime East Point location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "apartments-near-georgia-sports-park-east-point",
      "search_query": "apartments near Georgia Sports Park East Point",
      "category": "Park",
      "h1_title": "Apartments Near Georgia Sports Park",
      "h2_subtitle": "Experience active living at Cameron Run with apartments just minutes away from Georgia Sports Park in East Point.",
      "page_copy": "Cameron Run offers apartment homes conveniently located near Georgia Sports Park in East Point. The community provides convenient access to recreational opportunities, local amenities, and nearby destinations.\n\nCommunity features include a fitness center, gated entrance, pet-friendly amenities, and on-site professional management. Cameron Run combines modern apartment amenities with convenient access to shopping, dining, entertainment, and recreational facilities throughout the East Point area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Sports Park East Point",
      "seo_description": "Discover Cameron Run's apartments near Georgia Sports Park, blending modern comfort with proximity to East Point's recreational hub.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "apartments-near-hartsfield-jackson-atlanta-airport",
      "search_query": "apartments near Hartsfield-Jackson Atlanta International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Hartsfield-Jackson Airport",
      "h2_subtitle": "Cameron Run offers convenient apartments near Hartsfield-Jackson Atlanta International Airport.",
      "page_copy": "Cameron Run offers apartment homes conveniently located near Hartsfield-Jackson Atlanta International Airport in East Point. The community provides convenient access to transportation, local amenities, and nearby destinations throughout Fulton County.\n\nCommunity features include a gated entrance, pet-friendly amenities, a fitness center, and on-site professional management. Cameron Run combines modern apartment amenities with a convenient location near the airport and other area attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hartsfield-Jackson Airport",
      "seo_description": "Explore Cameron Run's apartments near Hartsfield-Jackson Atlanta International, blending convenience with modern living in East Point.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "flats-in-college-park-ga",
      "search_query": "flats in College Park GA",
      "category": "Transit",
      "h1_title": "Flats in College Park, GA",
      "h2_subtitle": "Discover Cameron Run's elegant flats in College Park, GA, offering a blend of comfort and convenience in a vibrant setting.",
      "page_copy": "Explore the spacious and stylish flats in College Park, GA, at Cameron Run, where contemporary design meets everyday comfort. Located just a short drive from the bustling heart of College Park, our community provides an ideal living environment for those seeking easy access to local amenities and attractions.\n\nCameron Run features a series of well-appointed flats, emphasizing a comfortable lifestyle with amenities such as a fitness center and a gated entrance to ensure security and privacy. Our pet-friendly policy makes it a welcoming choice for all members of the family. With on-site professional management, residents receive the support they need for an enjoyable living experience. Discover how Cameron Run can be the perfect fit for your lifestyle in College Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flats in College Park, GA",
      "seo_description": "Find modern flats in College Park, GA at Cameron Run, equipped with top amenities and located close to local attractions for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "residences-by-airport-east-point",
      "search_query": "residences by Airport East Point",
      "category": "Transit",
      "h1_title": "Residences by Airport in East Point",
      "h2_subtitle": "Cameron Run offers ideal residences by the airport in East Point, perfect for convenient and connected living.",
      "page_copy": "Cameron Run offers apartment homes in East Point with convenient access to Hartsfield-Jackson Atlanta International Airport. The community combines modern apartment amenities with a location near transportation, shopping, dining, and entertainment destinations throughout Fulton County.\n\nCommunity features include a gated entrance, pet-friendly amenities, a fitness center, and on-site professional management. Cameron Run provides convenient access to local services, attractions, and nearby airport facilities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences by Airport in East Point",
      "seo_description": "Discover convenient residences by the airport in East Point at Cameron Run, offering modern amenities and easy airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167331",
      "source": "custom",
      "page_item_url": "east-point-ga-public-transit-apartments",
      "search_query": "East Point GA public transit apartments",
      "category": "Transit",
      "h1_title": "East Point GA Public Transit Apartments",
      "h2_subtitle": "Find convenient public transit apartments in East Point, GA at Cameron Run, making commuting simple and easy.",
      "page_copy": "Cameron Run is the perfect choice for those seeking East Point GA public transit apartments. Our location offers effortless access to public transportation, making commuting a breeze and connecting you to the wider Atlanta area seamlessly.\n\nOur apartment community is designed for accessibility and comfort, featuring modern amenities including a fitness center and pet-friendly policies. The gated environment provides security and peace of mind, while on-site professional management ensures all your needs are promptly addressed. Nestled in the vibrant environment of East Point, Cameron Run's ideal location near public transit options means you can enjoy both the excitement of city life and the tranquility of a residential community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "East Point GA Public Transit Apartments",
      "seo_description": "Cameron Run offers public transit-friendly apartments in East Point GA, providing easy commuting and modern amenities for residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6074"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056378"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PX2WHQB4"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "863b311ef7edb6cb"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "274603731"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "ebc5f8e3dbf0a1f7552a"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a135031a-d0cb-11f0-a5a9-4b64d158f641"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/cameronrun/uploads/assets/untitled-video-4.fb4c3391.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a135031a-d0cb-11f0-a5a9-4b64d158f641/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndBWFN3L3Q2RzFLZVNZb1NMWTJrK3c9PSIsInZhbHVlIjoieWprMTJ5NGJXL1h1OFRLbTBjZHRodz09IiwibWFjIjoiMTRjMWI0MjE1OGUyNDU5NDU1MWJiMmEzZjcxNGEwMWVkMDI3N2VmODcwMjM4NmMxY2YxZWJmOGQ2MzIzNDlmNyJ9"
    }
  ],
  "custom_qb_id": "6074",
  "custom_repli_id": "11671056378",
  "custom_google_gtm_id": "GTM-PX2WHQB4",
  "custom_knock_community_id": "863b311ef7edb6cb",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "274603731",
  "custom_call_rail_account_hash": "ebc5f8e3dbf0a1f7552a",
  "custom_eliseai_building_token": "a135031a-d0cb-11f0-a5a9-4b64d158f641",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/cameronrun/uploads/assets/untitled-video-4.fb4c3391.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a135031a-d0cb-11f0-a5a9-4b64d158f641/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndBWFN3L3Q2RzFLZVNZb1NMWTJrK3c9PSIsInZhbHVlIjoieWprMTJ5NGJXL1h1OFRLbTBjZHRodz09IiwibWFjIjoiMTRjMWI0MjE1OGUyNDU5NDU1MWJiMmEzZjcxNGEwMWVkMDI3N2VmODcwMjM4NmMxY2YxZWJmOGQ2MzIzNDlmNyJ9",
  "custom_audioeye_site_id": "c945257b-98c6-4008-8a7d-daa3e93bd38d",
  "custom_audioeye_site_hash": "363f81c628ae7a21f2826dc36b43aeb9"
};

export const generatedAt = '2026-10-01T17:23:36.957Z';
